import Echo from "laravel-echo";
import Pusher from "pusher-js";
Pusher.logToConsole = true;
const PusherClient = new Pusher("fitmewisekey", {
    cluster: "mt1",
    wsHost: "https://www.testsocket.fitmewise.com",
    wsPort: 6001,
    wssPort: 6001,
    forceTLS: false,
    disableStats: true,
    enabledTransports: ["ws", "wss"],
});
export const echo = new Echo({
    broadcaster: "pusher",
    client: PusherClient,
});
